import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./lib/cart";
import { useLenis, scrollTop } from "./lib/smooth";
import { Nav } from "./components/Nav";
import { Footer } from "./components/Footer";
import { CartDrawer } from "./components/CartDrawer";
import { AuthCallback } from "./components/AuthCallback";
import Home from "./pages/Home";
import Checkout from "./pages/Checkout";
import Admin from "./pages/Admin";
import Info from "./pages/Info";
import About from "./pages/About";

function AppRouter() {
  const location = useLocation();
  useEffect(() => {
    scrollTop();
  }, [location.pathname]);
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/info" element={<Info />} />
      <Route path="/about" element={<About />} />
    </Routes>
  );
}

function App() {
  useLenis();
  return (
    <CartProvider>
      <BrowserRouter>
        <Nav />
        <AppRouter />
        <Footer />
        <CartDrawer />
        <Toaster position="top-center" offset={80} richColors />
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
